export default __webpack_public_path__ + "static/media/sound.af126116.gif";